import { Component, OnInit, ViewChild } from '@angular/core';
import swal from 'sweetalert2';
import { environment } from '../../../../environments/environment';
import { LabcoreEmailFile } from '../../../shared/models/labcore-email-file.model';
import { LabcoreErrorStatusResponse } from '../../../shared/models/labcore-error-status-response.model';
import { LabcoreLaboratoryTests } from '../../../shared/models/labcore-laboratory-tests.model';
import { LabcoreOrder } from '../../../shared/models/labcore-order.model';
import { LabcoreRequest } from '../../../shared/models/labcore-request.model';
import { LaboratoryTestsService } from '../../../shared/services/laboratory-tests.service';
import { SessionService } from '../../../shared/services/session.service';
import { DeviceUtility } from '../../../shared/utilities/device.utility';
import { ModalSendEmailComponent } from '../modals/modal-send-email/modal-send-email.component';

@Component({
  selector: 'app-laboratory-tests-list',
  templateUrl: './laboratory-tests-list.component.html',
  styleUrls: ['./laboratory-tests-list.component.css']
})
export class LaboratoryTestsListComponent implements OnInit {

  @ViewChild(ModalSendEmailComponent) modalSendEmailComponent: ModalSendEmailComponent;

  showSpinnerLoading: boolean;

  public mostrarExamenes: boolean;

  public labcoreRequest: LabcoreRequest = new LabcoreRequest;

  public labcoreLaboratoryTest: LabcoreLaboratoryTests = new LabcoreLaboratoryTests;

  public labcoreErrorStatusResponse: LabcoreErrorStatusResponse = new LabcoreErrorStatusResponse;

  public labcoreEmailFile: LabcoreEmailFile = new LabcoreEmailFile();


  constructor(private _sessionService: SessionService,
    private _laboratoryTestsService: LaboratoryTestsService) { }


  ngOnInit() {
  }


  public getDocumentType(value: string): string {
    switch(value) {

      case "CEDULA DE CIUDADANIA":
        return "CC";

      case "CARNE DIPLOMATICO":
          return "CD";

      case "CEDULA EXTRANJERI":
        return "CE";

      case "IDENTIFICACION DIPLO":
        return "ID";

      case "PERSONERIA JURIDICA":
        return "PJ";

      case "CERTIFICADO DE NACID":
          return "CN";

      case "REGISTRO MERCANTIL":
        return "RM";

      case "NUMERO DE IDENTIFICA":
        return "NIT";

      case "PASAPORTE":
        return "PA";

      case "REGISTRO CIVIL":
        return "RC";

      case "NUMERO DE SOLICITUD":
        return "NS";

      case "TARJETA IDENTIDAD":
        return "TI";

      case "NUMERO UNICO DE IDEN":
        return "NUIP";

      case "PERMISO ESPECIAL":
        return "PEP";

      case "MATRIZ DE COLECTIVO":
        return "COLE";

      case "TIPO DE IDENTIFICACI":
        return "TE";

      case "MENOR SIN IDENTIFICA":
        return "MSI";

      case "ADULTO SIN IDENTIFIC":
        return "ASI";

      default:

    }
  }


  public setLabcoreRequest(documentType: string, documentId: string) {    
    this.labcoreRequest.OrderCount = environment.LABORATORY_TESTS.LABCORE_PARAMS.ORDER_COUNT;
    this.labcoreRequest.PatientDocumentType = this.getDocumentType(documentType);
    this.labcoreRequest.PatientDocumentNumber = documentId;//"1313";
    this.labcoreRequest.ReportCode = environment.LABORATORY_TESTS.LABCORE_PARAMS.REPORT_CODE;
  }


  public getLaboratoryTests(documentType: string, documentId: string) {
    this.showSpinnerLoading = true;

    this.setLabcoreRequest(documentType, documentId);

    this._laboratoryTestsService.getLaboratoryTests(this.labcoreRequest).subscribe(
      res => {

        if(res.estado != undefined && !res.estado.exito) {
          this.labcoreErrorStatusResponse = res;
          this.mostrarExamenes = false;
          this.showSwalError(this.labcoreErrorStatusResponse.estado.respuesta);
        }
        else {
          this.labcoreLaboratoryTest = res;

          this.labcoreLaboratoryTest.Orders.forEach(e => {
            let formatDate = e.OrderDate.toString();
            formatDate = formatDate.substring(0, 4) + "-" + formatDate.substring(4, 6) + "-" + formatDate.substring(6, 8);
            let newDate = new Date(formatDate);
            e.OrderDate = new Date(newDate.setHours(newDate.getHours() + environment.LABORATORY_TESTS.ORDER_DATE));
          });
          
          this.mostrarExamenes = true;
        }
        
        this.showSpinnerLoading = false;
      },
      err => {
        console.log(err);
        this.showSpinnerLoading = false;
      }
    );
  }


  public showSwalError(message: string) {
    swal({
      title: 'Error',
      html: '<p style="font-size:14px"> ' + message + '</p>',
      type: 'warning',
      confirmButtonClass: 'btn btn-primary',
      buttonsStyling: false,
      focusConfirm: false
    });
    return;
  }


  public base64StringToBlob (b64Data, contentType='', sliceSize=512) : Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }


  public showOrderPDF(resultPDF: Blob, orderNumber: string) {
    var resultPDFToBlob  = this.base64StringToBlob(resultPDF, 'application/pdf');

    if (DeviceUtility.isMobileDevice()) {
      //var blob = new Blob([resultPDF]);
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(resultPDFToBlob);
      link.download = "Orden_" + orderNumber + ".pdf";
      link.click();
    }
    else {
      // Si es navegador web
      swal({
        width: 820,
        title: 'Orden de laboratorio',
        showCloseButton: true,
        html: `
        <object id="previewOrden" data="${window.URL.createObjectURL(resultPDFToBlob)}" type="application/pdf" width="800" height="800">            
        </object>       
        `,
        confirmButtonClass: 'btn btn-primary',
        confirmButtonText: 'Cerrar',
        allowOutsideClick: false,
        buttonsStyling: false,
        focusConfirm: false
      });
    }
  }


  public sendEmailOfOrderPDF(email: string, orderNumber: string, fileStringBase64: string) {

    // Abrir modal que permita ingresar el email al que se desea enviar el archivo
    
    this.labcoreEmailFile.emailUsuario = email;
    this.labcoreEmailFile.nombreUsuario = this._sessionService.getCurrentUser().name;
    this.labcoreEmailFile.numeroOrden = orderNumber;
    this.labcoreEmailFile.archivoStringBase64 = fileStringBase64;

    this._laboratoryTestsService.sendEmailOfOrderPDF(this.labcoreEmailFile).subscribe(
      res => {
          
      },
      err => {
        
      }
    );
  }


  showModalSendEmail(order: LabcoreOrder): void{
    this.modalSendEmailComponent.showDialog(order);
  }

}



// WEBPACK FOOTER //
// /app/src/app/office/laboratory-tests/laboratory-tests-list/laboratory-tests-list.component.ts